import store from '..';
import * as types from '../mutation-types'

export default {
	namespaced: true,
	state: {
		stockId: null,
		balance: null,
		target: {},
		financialTarget: {},
		salary: {},
		leaves: {},
		review: {}
	},

	actions: {
		target({ commit }) {
			return window.axios.get('/targets/mine')
				.then((response) => {
					commit(types.STORE_TARGET, response.data);
					return response.data;
				})
		},

		financialTarget({ commit }) {
			return window.axios.get('/targets/financial/mine')
				.then((response) => {
					commit(types.STORE_FINANCIAL_TARGET, response.data);
					return response.data;
				})
		},

		salary({ commit }) {
			return window.axios.get('/salaries/mine/latest')
				.then((response) => {
					commit(types.STORE_SALARY, response.data);
					return response.data;
				})
		},

		review({ commit }) {
			return window.axios.get('/reviews/mine')
				.then((response) => {
					commit(types.STORE_REVIEW, response.data);
					return response.data;
				})
		},

		leaves({ commit }, { employeeId }) {
			return window.axios.get('/leaves', { params: { employeeId } }).then(response => {
				commit(types.STORE_LEAVES, response.data);
				return response.data;
			})
		},
		
		fetchBalance({ commit }) {
			return window.axios.get('/employeeStock/mine').then(({ data }) => {
				if (!data) {
					return null;
				} else {
					commit(types.STORE_BALANCE, { stockId: data.id, balance: data.closingBalance });
					return data.closingBalance;
				}
			})
		},

		creatDayOff({ commit }, { date, reason, type, days }) {
			return window.axios.post('/requests/daysoff', { date, reason, type, days });
		},
		
		createBalance({ commit }) {
			return window.axios.post('/employeeStock', {
				employeeId: store.state.auth.self.employeeId,
				date: new Date().toISOString().slice(0, 10),
				amountReceived: 0,
				isPosted: false
			})
		},
		
		updateBalance({ state, commit }, { date, receivedAmount }) {
			return window.axios.put(`/employeeStock/${state.stockId}`, {
				date,
				employeeId: store.state.auth.self.employeeId,
				amountReceived: receivedAmount
			})
		},

		reset({ commit }) {
			commit(types.RESET_PROFILE);
		}

	},

	mutations: {
		[types.STORE_TARGET](state, target) {
			state.target = target;
		},

		[types.STORE_FINANCIAL_TARGET](state, financialTarget) {
			state.financialTarget = financialTarget;
		},

		[types.STORE_BALANCE](state, { stockId, balance }) {
			state.stockId = stockId;
			state.balance = balance;
		},

		[types.STORE_SALARY](state, salary) {
			state.salary = salary;
		},

		[types.STORE_LEAVES](state, leaves) {
			state.leaves = leaves;
		},

		[types.STORE_REVIEW](state, review) {
			state.review = review;
		},

		[types.RESET_PROFILE](state) {
			state.target = {};
			state.salary = {};
			state.review = {};
		},
	}
}